import { SubscriptionPlanTypes } from "src/features/account/types";
export var ResellerCustomerPlanTypes = SubscriptionPlanTypes;
export var ResellerCustomerStatusTypes;
(function (ResellerCustomerStatusTypes) {
    ResellerCustomerStatusTypes["Pending"] = "pending";
    ResellerCustomerStatusTypes["Accepted"] = "accepted";
})(ResellerCustomerStatusTypes || (ResellerCustomerStatusTypes = {}));
